import React from 'react';
import moment from "moment";
import "./CustomerViewProposalHeader.scss"
import {Col, Row} from "react-bootstrap";

const CustomerViewProposalHeader = ({proposal, clientLogo, isMobile}) => {

    const logo = () => {
        return <div className="logo">
            <img src={clientLogo && clientLogo} alt='Client Logo'/>
        </div>
    }

    const companyDetails = () => {
        return <div className="company-details text-success">
            <div><strong>{proposal.client_name}</strong></div>
            <div><strong>{proposal.client_address}</strong></div>
            <div><strong>{proposal.client_city}, {proposal.client_state} {proposal.client_zip}</strong></div>
            <div><strong>{proposal.client_phone}</strong></div>
            <div><strong>{proposal.client_email}</strong></div>
        </div>
    }

    const arborist = () => {
        return <div className="arborist text-success">
            <div><strong>Arborist:</strong></div>
            <div>{proposal.sales_arborist_name}</div>
            <div>{proposal.arborist_phone}</div>
            <div>{proposal.arborist_email}</div>
        </div>
    }

    const proposalDetails = () => {
        return <div className="proposal-details text-success">
            <Row>
                <b>Proposal No.</b>
                <span>{proposal.proposal_no}</span>
            </Row>
            <Row>
                <strong>Date:</strong>
                <span>{moment(proposal.proposal_date).format('YYYY/MM/DD')}</span>
            </Row>
            <Row>
                <strong>Title:</strong>
                <span>{proposal.proposal_title}</span>
            </Row>
        </div>
    }

    const customerInfo = () => {
        return <div className="customer text-danger">
            <Row>
                <strong>Customer:</strong>
                <span>{proposal.customer_name}</span>
            </Row>
            <Row>
                <strong>Site:</strong>
                <span>{proposal.site_name}</span>
            </Row>
        </div>
    }

    const customerSite = () => {
        return <div className="customer-site text-danger">
            <Row>
                <strong>Site Address</strong>
                <span>{proposal.site_full_address}</span>
            </Row>
            <Row>
                <strong>Purchase Order</strong>
                <span>{proposal.purchase_order}</span>
            </Row>
        </div>
    }

    return (
        !isMobile ? <div className="customer-view-header">
                {logo()}
                {companyDetails()}
                {arborist()}
                {proposalDetails()}
                {customerInfo()}
                {customerSite()}
            </div>
            :
            <div className={`customer-view-header fit-content-height`}>
                {logo()}
                {companyDetails()}
                {arborist()}
                {proposalDetails()}

                <div className="text-danger">
                    <Row>
                        <strong>Customer:</strong>
                        <span>{proposal.customer_name}</span>
                    </Row>
                    <Row>
                        <strong>Purchase Order</strong>
                        <span>{proposal.purchase_order}</span>
                    </Row>
                    <Row>
                        <strong>Site:</strong>
                        <span>{proposal.site_name}</span>
                    </Row>
                    <Row className="site-address row">
                        <strong>Site Address</strong>
                        <span>{proposal.site_full_address}</span>
                    </Row>
                </div>

            </div>
    );
};

export default CustomerViewProposalHeader;